import { render, staticRenderFns } from "./assetsDialog.vue?vue&type=template&id=47fabaf6&scoped=true"
import script from "./assetsDialog.vue?vue&type=script&lang=js"
export * from "./assetsDialog.vue?vue&type=script&lang=js"
import style0 from "./assetsDialog.vue?vue&type=style&index=0&id=47fabaf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fabaf6",
  null
  
)

export default component.exports